module.exports = __webpack_public_path__ + "img/lyct.cbd42da8.png";